type Props = {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  icon?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  icon,
}: Props) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold tracking-wide text-accent-900 ${
            isCenter ? "mx-auto" : ""
          }`}
        >
          {icon && <i className={`${icon} text-sm`}></i>}
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}